export const FETCH_PRICING_PLANS = "FETCH_PRICING_PLANS";
export const CHANGE_PRICING_PLAN = "CHANGE_PRICING_PLAN";
export const SELECT_PRICING_PLAN = "SELECT_PRICING_PLAN";

export const SIGN_UP_BEGIN = "SIGN_UP_BEGIN";
export const SIGN_UP_SUCCESS = "SIGN_UP_SUCCESS";
export const SIGN_UP_FAILURE = "SIGN_UP_FAILURE";

export const VERIFY_EMAIL_BEGIN = "VERIFY_EMAIL_BEGIN";
export const VERIFY_EMAIL_SUCCESS = "VERIFY_EMAIL_SUCCESS";
export const VERIFY_EMAIL_FAILURE = "VERIFY_EMAIL_FAILURE";

export const SET_LOGIN_USER_STATUS = "SET_LOGIN_USER_STATUS";
export const START_LOGIN = "START_LOGIN";
export const CLEAR_AUTH_DATA = "CLEAR_AUTH_DATA";

export const LOGIN_EMAIL_VERIFY = "LOGIN_EMAIL_VERIFY";

export const FORGET_PASSWORD_STARTED = "FORGET_PASSWORD_STARTED";
export const FORGET_PASSWORD_SUCCESS = "FORGET_PASSWORD_SUCCESS";

export const RESET_PASSWORD_STARTED = "RESET_PASSWORD_STARTED";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";

export const SET_USER_PROFILE_DATA = "SET_USER_PROFILE_DATA";
export const UPDATE_PASSWORD_STARTED = "UPDATE_PASSWORD_STARTED";

export const UPDATE_PROFILE_STARTED = "UPDATE_PROFILE_STARTED";
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS";

export const UPDATE_ORGANIZATION_STARTED = "UPDATE_ORGANIZATION_STARTED";
export const UPDATE_ORGANIZATION_SUCCESS = "UPDATE_ORGANIZATION_SUCCESS";

export const CHARGE_BEGIN = "CHARGE_BEGIN";
export const CHARGE_SUCCESS = "CHARGE_SUCCESS";
export const CHARGE_FAILURE = "CHARGE_FAILURE";

export const APPLY_COUPON_STARTED = "APPLY_COUPON_STARTED";
export const APPLY_COUPON_SUCCESS = "APPLY_COUPON_SUCCESS";
export const SET_REMOVE_COUPON = "SET_REMOVE_COUPON";

export const FETCH_CUSTOMERS_STARTED = "FETCH_CUSTOMERS_STARTED";
export const FETCH_CUSTOMERS_SUCCESS = "FETCH_CUSTOMERS_SUCCESS";
export const CUSTOMERS_FETCHED_STATUS = "CUSTOMERS_FETCHED_STATUS";

export const CANCEL_SUBSCRIPTION_STARTED = "CANCEL_SUBSCRIPTION_STARTED";
export const CANCEL_SUBSCRIPTION_SUCCESS = "CANCEL_SUBSCRIPTION_SUCCESS";

export const FETCH_INVOICES_STARTED = "FETCH_INVOICES_STARTED";
export const FETCH_INVOICES_SUCCESS = "FETCH_INVOICES_SUCCESS";
export const INVOICES_FETCHED_STATUS = "INVOICES_FETCHED_STATUS";

export const FETCH_UPGRADE_PLAN_INVOICE_STARTED = "FETCH_UPGRADE_PLAN_INVOICE_STARTED";
export const FETCH_UPGRADE_PLAN_INVOICE_BEGIN = "FETCH_UPGRADE_PLAN_INVOICE_BEGIN";
export const FETCH_UPGRADE_PLAN_INVOICE_SUCCESS = "FETCH_UPGRADE_PLAN_INVOICE_SUCCESS";

export const UPGRADE_PLAN_STARTED = "UPGRADE_PLAN_STARTED";
export const UPGRADE_PLAN_SUCCESS = "UPGRADE_PLAN_SUCCESS";